import sectionOrderInfoCss from '../css-snippets/section-order-info';

const html = `
<style>${sectionOrderInfoCss}</style>
<div 
  id="order-info-section-unique-id" 
  data-id="unique-id" 
  class="order-info-section" 
  data-attribute="order-info" 
  data-title="Order Info"
>
  <!-- Timeline Section -->
  <div class="timeline" data-timeline-enabled="true" data-timeline-shipping-days="10" data-timeline-delivery-days="5" data-timeline-circle-bg-color="#000000" data-timeline-svg-color="#ffffff" style="--timeline-enabled: grid; --timeline-circle-bg-color: #000000; --timeline-svg-color: #ffffff;">
    <div class="timeline-line"></div>

    <div class="timeline-step">
      <div class="timeline-circle">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke-width="1.5" 
          stroke="currentColor" 
          aria-hidden="true" 
          data-slot="icon" 
          >
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"></path>
        </svg>
      </div>
      <div class="timeline-text">
        <p class="date order-date"></p>
        <p>Ordered</p>
      </div>
    </div>

    <div class="timeline-step">
      <div class="timeline-circle">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke-width="1.5" 
          stroke="currentColor" 
          aria-hidden="true" 
          data-slot="icon" 
          >
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 0-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12"></path>
        </svg>
      </div>
      <div class="timeline-text">
        <p class="date shipping-date"></p>
        <p>Shipping</p>
      </div>
    </div>

    <div class="timeline-step">
      <div class="timeline-circle">
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke-width="1.5" 
          stroke="currentColor" 
          aria-hidden="true" 
          data-slot="icon" 
          >
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 11.25v8.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5v-8.25M12 4.875A2.625 2.625 0 1 0 9.375 7.5H12m0-2.625V7.5m0-2.625A2.625 2.625 0 1 1 14.625 7.5H12m0 0V21m-8.625-9.75h18c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125h-18c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125Z"></path>
        </svg>
      </div>
      <div class="timeline-text">
        <p class="date delivered-date"></p>
        <p>Delivered</p>
      </div>
    </div>
  </div>

  <!-- Accordion Section -->
  <div class="accordion" data-accordion-enabled="true" data-accordion-hover-color="#f3f4f6" data-accordion-border-color="#e5e7eb" style="--accordion-enabled: true; --accordion-hover-color: #f3f4f6; --accordion-border-color: #e5e7eb;">
    <div class="accordion-item">
      <div class="accordion-header" data-attribute="accordion-header">
        <span data-attribute="accordion-title" class="accordion-title">Shipping Rule</span>
        <span class="chevron" data-attribute="accordion-icon">
          <svg 
            aria-hidden="true" 
            focusable="false" 
            class="icon icon-caret" 
            viewBox="0 0 10 6"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
          </svg>
        </span>
      </div>
      <div class="accordion-content" data-attribute="accordion-content">
        <div><p><strong>Our Policy:</strong></p><p>1.&nbsp;Shipping costs vary depending on the shipping destination and the number of items that you purchase.&nbsp;The shipping cost will automatically update and display in your total costs.</p><p>2. After you successfully ordered, it takes a few days to process your order and then&nbsp;the packages will be shipped successfully in&nbsp;9 - 14 business days.&nbsp;</p><p><em>For more information, check out the</em><strong><em> Shipping &amp; Delivery </em></strong><em>at our website footer </em></p></div>
      </div>
    </div>

    <div class="accordion-item">
      <div class="accordion-header" data-attribute="accordion-header">
        <span data-attribute="accordion-title" class="accordion-title">Return & Refund</span>
        <span class="chevron" data-attribute="accordion-icon">
           <svg 
            aria-hidden="true" 
            focusable="false" 
            class="icon icon-caret" 
            viewBox="0 0 10 6"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
          </svg>
        </span>
      </div>
      <div class="accordion-content" data-attribute="accordion-content">
        <div><p><strong>Our Guarantee:</strong></p><p>1. You have only&nbsp;<strong>7 days of the arrival date</strong>&nbsp;to&nbsp;report damaged/broken/missing items with photographic evidence. No refunds or exchanges can be offered after this period.</p><p>2. If you are not happy with your purchase for any reason, you can return the package&nbsp;<strong><u>within</u>&nbsp;30 days</strong>&nbsp;from the delivery date.&nbsp;Please contact our customer service before returning, we will try our best to deal with your problem.</p><p><em>For more information, check out the </em><strong><em>Refund &amp; Return Policy </em></strong><em>at our website footer.</em></p></div>
      </div>
    </div>

  </div>

  <!-- Review Slider Section -->
  <div class="policy-review-grid-wrapper">
    <div data-attribute="body-review" class="swiper body-review">
      <div class="review-slider swiper-wrapper">
        <div data-attribute="item-review" class="item-review swiper-slide">
          <div class="reviewer-avatar">
            <img loading="lazy" data-attribute="reviewer-avatar" src="https://cdn.latteprint.com/latte/2025-08-22/1755856805959-123.jpg" alt="" onerror="this.style.display='none'">
          </div>  
          <div class="reviewer-details">
            <div class="review-content" data-attribute="review-content">
              Great Product!
            </div> 
            <div class="reviewer-info">
              <h3 data-attribute="reviewer-name" class="reviewer-name">Customer</h3>
              <div data-attribute="rating-stars" data-value="5" class="wrap-stars">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path></svg>          
              </div>      
            </div>        
          </div>    
        </div>
      </div>  
      <div class="swiper-pagination"></div>
    </div>    
  </div>

</div>
`;

export default html;
